


































































































































































































import { defineComponent, ref } from "@vue/composition-api";
import { currentERCProtocolsFilters as setCurrentFilters } from "../utils/defaultCurrentFilters";
import SelectFilter from "@monorepo/uikit/src/components/common/Select/SelectFilter.vue";
import TextFilter from "@monorepo/uikit/src/components/tableViews/TextFilter.vue";
import DatePicker from "@monorepo/uikit/src/components/tableViews/DatePicker.vue";
import CheckboxElement from "@monorepo/uikit/src/components/Settings/CheckboxElement.vue";
import { mapActions, mapGetters } from "vuex";
import { viewUniqKey } from "@monorepo/utils/src/variables/projectsData/tkGeneration/viewTitle";
import { filtersElements } from "@monorepo/utils/src/variables/projectsData/tkGeneration/filtersElements";
import { fields } from "@monorepo/utils/src/variables/projectsData/tkGeneration/fields";
import { convertToSelectItems } from "@monorepo/utils/src/utils/convertToSelectItems";
import eventBus from "@monorepo/utils/src/eventBus";
import useFilter from "@monorepo/utils/src/composables/useFilter";
import { standardMask } from "@monorepo/utils/src/directives/standardMask";
import mask from "@monorepo/utils/src/directives/mask";
import { v4 as uuid } from "uuid";
import { cloneDeep } from "lodash";

export default defineComponent({
  components: {
    TextFilter,
    DatePicker,
    CheckboxElement,
    SelectFilter,
  },
  directives: {
    mask,
  },
  data() {
    return {
      filters: setCurrentFilters(),
      filtersElements,
      viewUniqKey,
      fields,
      guidMask: cloneDeep(standardMask.guid),
    };
  },
  computed: {
    ...mapGetters("tkGeneration", ["fieldFilters", "fileTypes", "oiks", "isTableLoading"]),
    fileTypesSelectItems(): { title: string; value: string }[] {
      return convertToSelectItems(this.fileTypes);
    },
    oiksSelectItems(): { title: string; value: string }[] {
      return convertToSelectItems(this.oiks, "shortName", "code");
    },
  },
  methods: {
    ...mapActions("tkGeneration", ["clearFilters", "addFilter"]),
    setCurrentFilters,
    generateRandomValue(key: string) {
      this.addFilterInputValue(key, uuid());
    },
    addFilterInputValue(key: string, value: string | boolean) {
      this.filters[key] = value;
      this.addFilter(this.filters);
    },
    clearAllFilters({ id }: { id: number }) {
      if (id === 26) {
        this.filters = setCurrentFilters();
        this.addFilter(this.filters);
      }
    },
    resetInventoryKind(key: string, value: boolean) {
      this.addFilterInputValue(key, value);
      if (!value) {
        return;
      }
      const isPaperOnly = key === fields.FILTERS_ERC_ADD_PAPER_CASE;
      const inventoryKindKey = !isPaperOnly ? fields.FILTERS_ERC_ADD_PAPER_CASE : fields.FILTERS_ERC_ADD_CASE;
      this.filters[inventoryKindKey] = false;
      if (isPaperOnly) {
        this.filters[fields.FILTERS_ERC_PROTOCOLS_FILE_TYPE] = "";
        this.filters[fields.FILTERS_ERC_PROTOCOLS_MIN_SIZE] = "";
        this.filters[fields.FILTERS_ERC_PROTOCOLS_MAX_SIZE] = "";
        this.filters[fields.FILTERS_ERC_PROTOCOLS_APPLICATIONS_NUMBER] = "";
        this.filters[fields.FILTERS_ERC_PROTOCOLS_EAD_NUMBER] = "";
      }
      this.addFilter(this.filters);
    },
  },
  mounted() {
    this.addFilter(this.filters);
  },
  beforeMount() {
    eventBus.$on("newNotification", this.clearAllFilters);
  },
  beforeDestroy() {
    eventBus.$off("newNotification", this.clearAllFilters);
  },
  setup(props, context) {
    const currentFilters = ref({});
    const notHiddenKeys = ref([] as string[]);
    const isShowToggle = ref(false);
    const { filter } = useFilter(
      context,
      { value: true },
      "tkGeneration",
      {},
      currentFilters,
      () => ({}),
      filtersElements as { value: string; title: string }[],
      notHiddenKeys,
      isShowToggle
    );

    return {
      filter,
    };
  },
});
